import PropTypes from "prop-types";
import { Alert, Typography } from "@mui/material";
import DeviceActionDialog from "./DeviceActionDialog";
export default function ResetReaderConfirmationDialog({
  open,
  onClose,
  onConfirm,
  selectedReader,
  resetLoading = false,
}) {
  return (
    <DeviceActionDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title="Reiniciar reader"
      subtitle={selectedReader?.hostname || "Dispositivo seleccionado"}
      actionLabel="Reiniciar reader"
      loading={resetLoading}
      disabled={!selectedReader?.hostId || selectedReader?.isOnCooldown}
      fields={[
        ["Reader", selectedReader?.hostname],
        ["IP", selectedReader?.ip],
        ["Comercio", selectedReader?.commerce],
        ["ID host", selectedReader?.hostId],
      ]}
    >
      <Alert severity={selectedReader?.isOnCooldown ? "info" : "warning"}>
        {selectedReader?.isOnCooldown
          ? `Este reader está en espera. Quedan ${
              selectedReader.cooldownInfo?.remainingSeconds ?? "—"
            } segundos.`
          : "Se enviará el reinicio únicamente a este reader. Sus antenas pueden dejar de responder durante la operación."}
      </Alert>
      <Typography variant="body2" sx={{ mt: 2, color: "#475569" }}>
        ¿Deseas reiniciar este dispositivo?
      </Typography>
    </DeviceActionDialog>
  );
}
ResetReaderConfirmationDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  selectedReader: PropTypes.object,
  resetLoading: PropTypes.bool,
};
